import React from 'react';
import TextBlock, { type Props as TextBlockProps } from '../../../react4xp/components/TextBlock'

function TextBlockPart (props: TextBlockProps) {
  return (
    <TextBlock {...props} />
  )
}

export default (props: TextBlockProps) => <TextBlockPart {...props} />


